const realTimeChannels = {
  AiJobSummaryChannel: 'AiJobSummaryChannel',
  BulkDownloadResultChannel: 'BulkDownloadResultChannel',
  BulkSendJobsChannel: 'BulkSendJobsChannel',
  CompanyDayJobStatChannel: 'CompanyDayJobStatChannel',
  CompanyJobJobEventChannel: 'CompanyJobJobEventChannel',
  CompanyJobUpdateChannel: 'CompanyJobUpdateChannel',
  CompanyOrderUpdateChannel: 'CompanyOrderUpdateChannel',
  CompanyProjectEventChannel: 'CompanyProjectEventChannel',
  DeploymentChannel: 'DeploymentChannel',
  DriverDayUpdateChannel: 'DriverDayUpdateChannel',
  DriversTypeaheadDayChannel: 'DriversTypeaheadDayChannel',
  FileDownloadResultChannel: 'FileDownloadResultChannel',
  InaccessibleJobChannel: 'InaccessibleJobChannel',
  InvoiceUpdateChannel: 'InvoiceUpdateChannel',
  JobETAChannel: 'JobETAChannel',
  JobInvoicingUpdateChannel: 'JobInvoicingUpdateChannel',
  JobLoadActivityChannel: 'JobLoadActivityChannel',
  LiveSiteChannel: 'LiveSiteChannel',
  MessagingTypingChannel: 'MessagingTypingChannel',
  MessagingUserChannel: 'MessagingUserChannel',
  NextBillionLastLocationChannel: 'NextBillionLastLocationChannel',
  OrderIntakeChannel: 'OrderIntakeChannel',
  OutboundEmailChannel: 'OutboundEmailChannel',
  RutterItemRuleChannel: 'RutterItemRuleChannel',
  SettlementUpdateChannel: 'SettlementUpdateChannel',
  SplitJobResultChannel: 'SplitJobResultChannel',
  TicketUpdateChannel: 'TicketUpdateChannel',
  UserBulkAssignJobsChannel: 'UserBulkAssignJobsChannel',
  UserBulkCopyAssignmentsChannel: 'UserBulkCopyAssignmentsChannel',
  UserBulkCreateSettlementChannel: 'UserBulkCreateSettlementChannel',
  UserBulkExportSettlementsChannel: 'UserBulkExportSettlementsChannel',
  UserTreadAgentChannel: 'UserTreadAgentChannel',
  VendorCapacityTypeaheadChannel: 'VendorCapacityTypeaheadChannel',
};
export { realTimeChannels };
